/* eslint-disable */
import PropTypes from 'prop-types';
import {
  THEME_BREAKPOINT_LG_STEP,
  THEME_BREAKPOINT_LG_UNIT,
  THEME_BREAKPOINT_MD_STEP,
  THEME_BREAKPOINT_MD_UNIT,
  THEME_BREAKPOINT_SM_STEP,
  THEME_BREAKPOINT_SM_UNIT,
  THEME_BREAKPOINT_XL_STEP,
  THEME_BREAKPOINT_XL_UNIT,
  THEME_BREAKPOINT_XS_STEP,
  THEME_BREAKPOINT_XS_UNIT,
} from '../../Constants/Theme/Theme.constants';
import { ENTRY_PORTAL_CUSTOMER_COMPANY, ENTRY_PORTAL_CUSTOMER_NAME } from '../../Entries/PortalCustomer/PortalCustomer.entry.constants';
import { ENTRY_PORTAL_OPERATIONS_COMPANY, ENTRY_PORTAL_OPERATIONS_NAME } from '../../Entries/PortalOperations/PortalOperations.entry.constants';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

/**
 * The breakpoints name for the `entry`
 */
const entryBreakpoints = PropTypes.arrayOf(
  PropTypes.oneOf([
    PropTypes.shape({
      step: THEME_BREAKPOINT_XS_STEP,
      unit: THEME_BREAKPOINT_XS_UNIT,
    }),
    PropTypes.shape({
      step: THEME_BREAKPOINT_SM_STEP,
      unit: THEME_BREAKPOINT_SM_UNIT,
    }),
    PropTypes.shape({
      step: THEME_BREAKPOINT_MD_STEP,
      unit: THEME_BREAKPOINT_MD_UNIT,
    }),
    PropTypes.shape({
      step: THEME_BREAKPOINT_LG_STEP,
      unit: THEME_BREAKPOINT_LG_UNIT,
    }),
    PropTypes.shape({
      step: THEME_BREAKPOINT_XL_STEP,
      unit: THEME_BREAKPOINT_XL_UNIT,
    }),
  ]),
).isRequired;

/**
 * The company name for the `entry`
 */
const entryCompany = PropTypes.oneOf([ENTRY_PORTAL_CUSTOMER_COMPANY, ENTRY_PORTAL_OPERATIONS_COMPANY]);

/**
 * The palette to use for the `entry`
 */
const entryPalette = PropTypes.shape({
  /**
   * The error color for the `entry`
   */
  error: ThemeStatePropTypes.color.isRequired,

  /**
   * The primary color for the `entry`
   */
  primary: ThemeStatePropTypes.color.isRequired,

  /**
   * The secondary color for the `entry`
   */
  secondary: ThemeStatePropTypes.color.isRequired,

  /**
   * The palette type to use for the `entry`
   */
  type: ThemeStatePropTypes.paletteType.isRequired,
});

/**
 * The shape to use for the `entry`
 */
const entryShape = PropTypes.shape({
  /**
   * The border radius to use for the `entry`
   */
  borderRadius: PropTypes.number.isRequired,
});

/**
 * The spacing to use for the `entry`
 */
const entrySpacing = PropTypes.shape({
  /**
   * The spacing unit to use for the `entry`
   */
  unit: PropTypes.number.isRequired,
});

/**
 * The name of the `entry`
 */
const entryName = PropTypes.oneOf([ENTRY_PORTAL_CUSTOMER_NAME, ENTRY_PORTAL_OPERATIONS_NAME]);

/**
 * The current `entry`
 */
const entry = PropTypes.shape({
  /**
   * The breakpoints name for the `entry`
   */
  breakpoints: entryBreakpoints.isRequired,

  /**
   * The company name for the `entry`
   */
  company: entryCompany.isRequired,

  /**
   * The logo 100x100 sized logo
   */
  logoLargeUrl: PropTypes.string.isRequired,

  /**
   * The name of the `entry`
   */
  name: entryName.isRequired,

  /**
   * The palette to use for the `entry`
   */
  palette: entryPalette.isRequired,

  /**
   * The link to redirect to after a successful login
   */
  postLoginLink: PropTypes.string.isRequired,

  /**
   * The link to redirect to after a successful logout
   */
  postLogoutLink: PropTypes.string.isRequired,

  /**
   * The shape to use for the `entry`
   */
  shape: entryShape.isRequired,

  /**
   * The spacing to use for the `entry`
   */
  spacing: entrySpacing.isRequired,

  /**
   * The version of this `entry`
   */
  version: PropTypes.number.isRequired,
});

const EntriesContextPropTypes = {
  /**
   * The breakpoints name for the `entry`
   */
  breakpoints: entryBreakpoints,

  /**
   * The company name for the `entry`
   */
  company: entryCompany,

  /**
   * The current `entry`
   */
  entry,

  /**
   * The name of the `entry`
   */
  name: entryName,

  /**
   * The palette to use for the `entry`
   */
  palette: entryPalette,

  /**
   * The spape to use for the `entry`
   */
  shape: entryShape,

  /**
   * The spacing to use for the `entry`
   */
  spacing: entrySpacing,
};

export default EntriesContextPropTypes;
